import CreatorAssets from "./CreatorAssets"
export default CreatorAssets
